"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
var constants_1 = require("../constants");
var default_1 = require("../provider/default");
var signer_1 = require("../signer");
var hash_1 = require("../utils/hash");
var number_1 = require("../utils/number");
var provider_1 = require("../utils/provider");
var stark_1 = require("../utils/stark");
var transaction_1 = require("../utils/transaction");
var typedData_1 = require("../utils/typedData");
var Account = /** @class */ (function (_super) {
    __extends(Account, _super);
    function Account(providerOrOptions, address, keyPairOrSigner) {
        var _this = _super.call(this, providerOrOptions) || this;
        _this.address = address.toLowerCase();
        _this.signer =
            'getPubKey' in keyPairOrSigner ? keyPairOrSigner : new signer_1.Signer(keyPairOrSigner);
        return _this;
    }
    Account.prototype.getNonce = function (blockIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, _super.prototype.getNonce.call(this, this.address, blockIdentifier)];
            });
        });
    };
    Account.prototype.estimateFee = function (calls, estimateFeeDetails) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.estimateInvokeFee(calls, estimateFeeDetails)];
            });
        });
    };
    Account.prototype.estimateInvokeFee = function (calls, _a) {
        var _b = _a === void 0 ? {} : _a, providedNonce = _b.nonce, blockIdentifier = _b.blockIdentifier;
        return __awaiter(this, void 0, void 0, function () {
            var transactions, nonce, _c, _d, version, chainId, signerDetails, signature, calldata, response, suggestedMaxFee;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        transactions = Array.isArray(calls) ? calls : [calls];
                        _c = number_1.toBN;
                        if (!(providedNonce !== null && providedNonce !== void 0)) return [3 /*break*/, 1];
                        _d = providedNonce;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getNonce()];
                    case 2:
                        _d = (_e.sent());
                        _e.label = 3;
                    case 3:
                        nonce = _c.apply(void 0, [_d]);
                        version = (0, number_1.toBN)(hash_1.transactionVersion);
                        return [4 /*yield*/, this.getChainId()];
                    case 4:
                        chainId = _e.sent();
                        signerDetails = {
                            walletAddress: this.address,
                            nonce: nonce,
                            maxFee: constants_1.ZERO,
                            version: version,
                            chainId: chainId,
                        };
                        return [4 /*yield*/, this.signer.signTransaction(transactions, signerDetails)];
                    case 5:
                        signature = _e.sent();
                        calldata = (0, transaction_1.fromCallsToExecuteCalldata)(transactions);
                        return [4 /*yield*/, _super.prototype.getInvokeEstimateFee.call(this, { contractAddress: this.address, calldata: calldata, signature: signature }, { version: version, nonce: nonce }, blockIdentifier)];
                    case 6:
                        response = _e.sent();
                        suggestedMaxFee = (0, stark_1.estimatedFeeToMaxFee)(response.overall_fee);
                        return [2 /*return*/, __assign(__assign({}, response), { suggestedMaxFee: suggestedMaxFee })];
                }
            });
        });
    };
    Account.prototype.estimateDeclareFee = function (_a, _b) {
        var classHash = _a.classHash, contract = _a.contract;
        var _c = _b === void 0 ? {} : _b, blockIdentifier = _c.blockIdentifier, providedNonce = _c.nonce;
        return __awaiter(this, void 0, void 0, function () {
            var nonce, _d, _e, version, chainId, contractDefinition, signature, response, suggestedMaxFee;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _d = number_1.toBN;
                        if (!(providedNonce !== null && providedNonce !== void 0)) return [3 /*break*/, 1];
                        _e = providedNonce;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getNonce()];
                    case 2:
                        _e = (_f.sent());
                        _f.label = 3;
                    case 3:
                        nonce = _d.apply(void 0, [_e]);
                        version = (0, number_1.toBN)(hash_1.transactionVersion);
                        return [4 /*yield*/, this.getChainId()];
                    case 4:
                        chainId = _f.sent();
                        contractDefinition = (0, provider_1.parseContract)(contract);
                        return [4 /*yield*/, this.signer.signDeclareTransaction({
                                classHash: classHash,
                                senderAddress: this.address,
                                chainId: chainId,
                                maxFee: constants_1.ZERO,
                                version: version,
                                nonce: nonce,
                            })];
                    case 5:
                        signature = _f.sent();
                        return [4 /*yield*/, _super.prototype.getDeclareEstimateFee.call(this, { senderAddress: this.address, signature: signature, contractDefinition: contractDefinition }, { version: version, nonce: nonce }, blockIdentifier)];
                    case 6:
                        response = _f.sent();
                        suggestedMaxFee = (0, stark_1.estimatedFeeToMaxFee)(response.overall_fee);
                        return [2 /*return*/, __assign(__assign({}, response), { suggestedMaxFee: suggestedMaxFee })];
                }
            });
        });
    };
    Account.prototype.estimateAccountDeployFee = function (_a, _b) {
        var classHash = _a.classHash, _c = _a.addressSalt, addressSalt = _c === void 0 ? 0 : _c, _d = _a.constructorCalldata, constructorCalldata = _d === void 0 ? [] : _d, providedContractAddress = _a.contractAddress;
        var _e = _b === void 0 ? {} : _b, blockIdentifier = _e.blockIdentifier, providedNonce = _e.nonce;
        return __awaiter(this, void 0, void 0, function () {
            var nonce, _f, _g, version, chainId, contractAddress, signature, response, suggestedMaxFee;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _f = number_1.toBN;
                        if (!(providedNonce !== null && providedNonce !== void 0)) return [3 /*break*/, 1];
                        _g = providedNonce;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getNonce()];
                    case 2:
                        _g = (_h.sent());
                        _h.label = 3;
                    case 3:
                        nonce = _f.apply(void 0, [_g]);
                        version = (0, number_1.toBN)(hash_1.transactionVersion);
                        return [4 /*yield*/, this.getChainId()];
                    case 4:
                        chainId = _h.sent();
                        contractAddress = providedContractAddress !== null && providedContractAddress !== void 0 ? providedContractAddress : (0, hash_1.calculateContractAddressFromHash)(addressSalt, classHash, constructorCalldata, 0);
                        return [4 /*yield*/, this.signer.signDeployAccountTransaction({
                                classHash: classHash,
                                contractAddress: contractAddress,
                                chainId: chainId,
                                maxFee: constants_1.ZERO,
                                version: version,
                                nonce: nonce,
                                addressSalt: addressSalt,
                                constructorCalldata: constructorCalldata,
                            })];
                    case 5:
                        signature = _h.sent();
                        return [4 /*yield*/, _super.prototype.getDeployAccountEstimateFee.call(this, { classHash: classHash, addressSalt: addressSalt, constructorCalldata: constructorCalldata, signature: signature }, { version: version, nonce: nonce }, blockIdentifier)];
                    case 6:
                        response = _h.sent();
                        suggestedMaxFee = (0, stark_1.estimatedFeeToMaxFee)(response.overall_fee);
                        return [2 /*return*/, __assign(__assign({}, response), { suggestedMaxFee: suggestedMaxFee })];
                }
            });
        });
    };
    Account.prototype.execute = function (calls, abis, transactionsDetail) {
        var _a, _b;
        if (abis === void 0) { abis = undefined; }
        if (transactionsDetail === void 0) { transactionsDetail = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var transactions, nonce, _c, _d, maxFee, _e, version, chainId, signerDetails, signature, calldata;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        transactions = Array.isArray(calls) ? calls : [calls];
                        _c = number_1.toBN;
                        if (!((_a = transactionsDetail.nonce) !== null && _a !== void 0)) return [3 /*break*/, 1];
                        _d = _a;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getNonce()];
                    case 2:
                        _d = (_f.sent());
                        _f.label = 3;
                    case 3:
                        nonce = _c.apply(void 0, [_d]);
                        if (!((_b = transactionsDetail.maxFee) !== null && _b !== void 0)) return [3 /*break*/, 4];
                        _e = _b;
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.getSuggestedMaxFee({ type: 'INVOKE', payload: calls }, transactionsDetail)];
                    case 5:
                        _e = (_f.sent());
                        _f.label = 6;
                    case 6:
                        maxFee = _e;
                        version = (0, number_1.toBN)(hash_1.transactionVersion);
                        return [4 /*yield*/, this.getChainId()];
                    case 7:
                        chainId = _f.sent();
                        signerDetails = {
                            walletAddress: this.address,
                            nonce: nonce,
                            maxFee: maxFee,
                            version: version,
                            chainId: chainId,
                        };
                        return [4 /*yield*/, this.signer.signTransaction(transactions, signerDetails, abis)];
                    case 8:
                        signature = _f.sent();
                        calldata = (0, transaction_1.fromCallsToExecuteCalldata)(transactions);
                        return [2 /*return*/, this.invokeFunction({ contractAddress: this.address, calldata: calldata, signature: signature }, {
                                nonce: nonce,
                                maxFee: maxFee,
                                version: version,
                            })];
                }
            });
        });
    };
    Account.prototype.declare = function (_a, transactionsDetail) {
        var _b, _c;
        var classHash = _a.classHash, contract = _a.contract;
        if (transactionsDetail === void 0) { transactionsDetail = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var nonce, _d, _e, maxFee, _f, version, chainId, signature, contractDefinition;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _d = number_1.toBN;
                        if (!((_b = transactionsDetail.nonce) !== null && _b !== void 0)) return [3 /*break*/, 1];
                        _e = _b;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getNonce()];
                    case 2:
                        _e = (_g.sent());
                        _g.label = 3;
                    case 3:
                        nonce = _d.apply(void 0, [_e]);
                        if (!((_c = transactionsDetail.maxFee) !== null && _c !== void 0)) return [3 /*break*/, 4];
                        _f = _c;
                        return [3 /*break*/, 6];
                    case 4: return [4 /*yield*/, this.getSuggestedMaxFee({ type: 'DECLARE', payload: { classHash: classHash, contract: contract } }, transactionsDetail)];
                    case 5:
                        _f = (_g.sent());
                        _g.label = 6;
                    case 6:
                        maxFee = _f;
                        version = (0, number_1.toBN)(hash_1.transactionVersion);
                        return [4 /*yield*/, this.getChainId()];
                    case 7:
                        chainId = _g.sent();
                        return [4 /*yield*/, this.signer.signDeclareTransaction({
                                classHash: classHash,
                                senderAddress: this.address,
                                chainId: chainId,
                                maxFee: maxFee,
                                version: version,
                                nonce: nonce,
                            })];
                    case 8:
                        signature = _g.sent();
                        contractDefinition = (0, provider_1.parseContract)(contract);
                        return [2 /*return*/, this.declareContract({ contractDefinition: contractDefinition, senderAddress: this.address, signature: signature }, {
                                nonce: nonce,
                                maxFee: maxFee,
                                version: version,
                            })];
                }
            });
        });
    };
    Account.prototype.deploy = function (_a, additionalCalls, // support multicall
    transactionsDetail) {
        var classHash = _a.classHash, salt = _a.salt, _b = _a.unique, unique = _b === void 0 ? true : _b, _c = _a.constructorCalldata, constructorCalldata = _c === void 0 ? [] : _c, _d = _a.isDevnet, isDevnet = _d === void 0 ? false : _d;
        if (additionalCalls === void 0) { additionalCalls = []; }
        if (transactionsDetail === void 0) { transactionsDetail = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var compiledConstructorCallData, callsArray;
            return __generator(this, function (_e) {
                compiledConstructorCallData = (0, stark_1.compileCalldata)(constructorCalldata);
                callsArray = Array.isArray(additionalCalls) ? additionalCalls : [additionalCalls];
                return [2 /*return*/, this.execute(__spreadArray([
                        {
                            contractAddress: isDevnet ? constants_1.UDC.ADDRESS_DEVNET : constants_1.UDC.ADDRESS,
                            entrypoint: constants_1.UDC.ENTRYPOINT,
                            calldata: __spreadArray([
                                classHash,
                                salt,
                                (0, number_1.toCairoBool)(unique),
                                compiledConstructorCallData.length
                            ], __read(compiledConstructorCallData), false),
                        }
                    ], __read(callsArray), false), undefined, transactionsDetail)];
            });
        });
    };
    Account.prototype.deployAccount = function (_a, transactionsDetail) {
        var _b, _c;
        var classHash = _a.classHash, _d = _a.constructorCalldata, constructorCalldata = _d === void 0 ? [] : _d, _e = _a.addressSalt, addressSalt = _e === void 0 ? 0 : _e, providedContractAddress = _a.contractAddress;
        if (transactionsDetail === void 0) { transactionsDetail = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var nonce, _f, _g, version, chainId, contractAddress, maxFee, _h, signature;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        _f = number_1.toBN;
                        if (!((_b = transactionsDetail.nonce) !== null && _b !== void 0)) return [3 /*break*/, 1];
                        _g = _b;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.getNonce()];
                    case 2:
                        _g = (_j.sent());
                        _j.label = 3;
                    case 3:
                        nonce = _f.apply(void 0, [_g]);
                        version = (0, number_1.toBN)(hash_1.transactionVersion);
                        return [4 /*yield*/, this.getChainId()];
                    case 4:
                        chainId = _j.sent();
                        contractAddress = providedContractAddress !== null && providedContractAddress !== void 0 ? providedContractAddress : (0, hash_1.calculateContractAddressFromHash)(addressSalt, classHash, constructorCalldata, 0);
                        if (!((_c = transactionsDetail.maxFee) !== null && _c !== void 0)) return [3 /*break*/, 5];
                        _h = _c;
                        return [3 /*break*/, 7];
                    case 5: return [4 /*yield*/, this.getSuggestedMaxFee({
                            type: 'DEPLOY_ACCOUNT',
                            payload: { classHash: classHash, constructorCalldata: constructorCalldata, addressSalt: addressSalt, contractAddress: contractAddress },
                        }, transactionsDetail)];
                    case 6:
                        _h = (_j.sent());
                        _j.label = 7;
                    case 7:
                        maxFee = _h;
                        return [4 /*yield*/, this.signer.signDeployAccountTransaction({
                                classHash: classHash,
                                constructorCalldata: constructorCalldata,
                                contractAddress: contractAddress,
                                addressSalt: addressSalt,
                                chainId: chainId,
                                maxFee: maxFee,
                                version: version,
                                nonce: nonce,
                            })];
                    case 8:
                        signature = _j.sent();
                        return [2 /*return*/, this.deployAccountContract({ classHash: classHash, addressSalt: addressSalt, constructorCalldata: constructorCalldata, signature: signature }, {
                                nonce: nonce,
                                maxFee: maxFee,
                                version: version,
                            })];
                }
            });
        });
    };
    Account.prototype.signMessage = function (typedData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.signer.signMessage(typedData, this.address)];
            });
        });
    };
    Account.prototype.hashMessage = function (typedData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, (0, typedData_1.getMessageHash)(typedData, this.address)];
            });
        });
    };
    Account.prototype.verifyMessageHash = function (hash, signature) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.callContract({
                                contractAddress: this.address,
                                entrypoint: 'isValidSignature',
                                calldata: (0, stark_1.compileCalldata)({
                                    hash: (0, number_1.toBN)(hash).toString(),
                                    signature: signature.map(function (x) { return (0, number_1.toBN)(x).toString(); }),
                                }),
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, true];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/, false];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Account.prototype.verifyMessage = function (typedData, signature) {
        return __awaiter(this, void 0, void 0, function () {
            var hash;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.hashMessage(typedData)];
                    case 1:
                        hash = _a.sent();
                        return [2 /*return*/, this.verifyMessageHash(hash, signature)];
                }
            });
        });
    };
    Account.prototype.getSuggestedMaxFee = function (estimateFeeAction, details) {
        return __awaiter(this, void 0, void 0, function () {
            var feeEstimate, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = estimateFeeAction.type;
                        switch (_a) {
                            case 'INVOKE': return [3 /*break*/, 1];
                            case 'DECLARE': return [3 /*break*/, 3];
                            case 'DEPLOY_ACCOUNT': return [3 /*break*/, 5];
                        }
                        return [3 /*break*/, 7];
                    case 1: return [4 /*yield*/, this.estimateInvokeFee(estimateFeeAction.payload, details)];
                    case 2:
                        feeEstimate = _b.sent();
                        return [3 /*break*/, 8];
                    case 3: return [4 /*yield*/, this.estimateDeclareFee(estimateFeeAction.payload, details)];
                    case 4:
                        feeEstimate = _b.sent();
                        return [3 /*break*/, 8];
                    case 5: return [4 /*yield*/, this.estimateAccountDeployFee(estimateFeeAction.payload, details)];
                    case 6:
                        feeEstimate = _b.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        feeEstimate = { suggestedMaxFee: constants_1.ZERO, overall_fee: constants_1.ZERO };
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/, feeEstimate.suggestedMaxFee.toString()];
                }
            });
        });
    };
    return Account;
}(default_1.Provider));
exports.Account = Account;
